import { Component, Inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-landing-ppk-downloader',
  templateUrl: './landing-ppk-downloader.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-ppk-downloader.component.scss']
})
export class LandingPpkDownloaderComponent implements OnInit {

  constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private doc: Document, private auth: AuthService) {}

  ngOnInit(): void {
    const CANON = 'https://geoastra.com';
    const url = `${CANON}/landing-ppk-downloader`;
    this.title.setTitle('PPK Downloader — GeoAstra');
    this.meta.updateTag({ name: 'description', content: 'Download and manage RTCM data for PPK workflows with GeoAstra PPK Downloader. Simple, fast, and secure.' });
    this.meta.updateTag({ property: 'og:title', content: 'PPK Downloader — GeoAstra' });
    this.meta.updateTag({ property: 'og:description', content: 'Download and manage RTCM data for PPK workflows.' });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:type', content: 'product' });
    this.meta.updateTag({ property: 'og:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: 'PPK Downloader — GeoAstra' });
    this.meta.updateTag({ name: 'twitter:description', content: 'RTCM data downloader for PPK workflows.' });
    this.meta.updateTag({ name: 'twitter:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    let link: HTMLLinkElement | null = this.doc.querySelector("link[rel='canonical']");
    if (!link) { link = this.doc.createElement('link'); link.setAttribute('rel', 'canonical'); this.doc.head.appendChild(link); }
    link.setAttribute('href', url);
  }

  login(): void { this.auth.login(); }
  signup(): void { this.auth.signup(); }
  redirectToEnterPrise() { window.location.href = 'https://gpswebshop.com/products/geoastra-ntrip-caster-enterprise-edition-12-month-subscription-service?variant=47996976169268'; }
  redirectToPro() { window.location.href = 'https://gpswebshop.com/products/geoastra-ntrip-caster-pro-edition-1-month-subscription-service?variant=47997022535988'; }
}


